import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-probioticos',
  templateUrl: './probioticos.component.html',
  styleUrls: []
})
export class ProbioticosComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="¿Cómo debe ser un buen probiótico? | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"¿Cómo debe ser un buen probiótico? | Sinuberase",
  		description: "Para recibir todos sus beneficios, es necesario que los probióticos estén vivos, en grandes cantidades y que puedan sobrevivir a las condiciones del aparato digestivo",
  		slug: "Probiotico"
  	})

  	this.seo.closeMenu();
  }

}
